// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a4712d27","488":"37c757b6","643":"f90cdabf","660":"c18c68b3"}[chunkId] + ".chunk.js";
};